import { AppDispatch, RootState } from 'src/store/store';
import { useDispatch, useSelector } from "react-redux";

import { Select as ChakraReactSelect } from "chakra-react-select";
import { Flex } from '@chakra-ui/react'
import GlobeIcon from '../resources/icons/GlobeIcon'
import React from 'react'
import { setGlobalInfo } from 'src/store/features/global';

export const GlobalLangSelector: React.FC = () => {
    const globalInfo = useSelector((state: RootState) => state.globalInfo);
    const dispatch = useDispatch<AppDispatch>();
    const { globalLanguage } = globalInfo;

   const changeGlobalLanguage = (value: string): void => {
    const lang = value || "EN";
    localStorage.setItem("lang", lang);   
    dispatch(setGlobalInfo({ globalLanguage: lang })); 
   };
    const options = [
        { value: "EN", label: "EN" },
        { value: "HI", label: "हिंदी" },
    ];
    
    return (
        <>
            <Flex alignItems="center">
                <GlobeIcon />
                <ChakraReactSelect
                    options={options}
                    value={options.find((option) => option.value === globalLanguage)}
                    onChange={(selectedOption) => changeGlobalLanguage(selectedOption?.value || "")}
                    chakraStyles={{
                        control: (provided) => ({
                            ...provided,
                            width: "5.4rem",
                            borderColor: "transparent",
                            backgroundColor: "transparent",
                            minHeight: "2rem",
                        }),
                        dropdownIndicator: (provided) => ({
                            ...provided,
                            padding: 0,
                            backgroundColor: "transparent",
                        }),
                        indicatorSeparator: () => ({
                            display: "none",
                        }),
                    }}
                />
            </Flex>
        </>
    )
}

